<template>
  <div id='stepHeader'>
    <!--<div v-if="this.$store.state.currentPage==='/'||this.$store.state.currentPage===''" style="border: 1px solid rgb(204, 204, 204); padding:40px; margin-left: 20px; margin-bottom: 50px;">
        <p class="cov_disclaimer_text" v-html='$t("text.covDisclaimer")'> {{$t("text.covDisclaimer")}}</p>
    </div>-->
    <div v-if='progressHeaderKey' class='textStepProgress'>{{$t(progressHeaderKey)}}</div>
    <div class='row no-gutters'>
      <h1 id='stepTitle' tabindex='-1' class='textStepTitle col-12'>{{stepHeaderText}}<span id='stepTitleAppend'></span></h1>
      <div v-if='hasInstructions' class='textInstructions col-12' v-html='instructionsText' style='margin-left:20px;'></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepHeader',
  computed: {
    progressHeaderKey() {
      return this.$route.meta && this.$route.meta.progressHeader && this.$route.meta.progressHeader.trim() !== '' 
        ? this.$route.meta.progressHeader 
        : null;
    },
    stepHeaderText() {
      if (!this.$route.meta || !this.$route.meta.stepHeader || this.$route.meta.stepHeader.trim() === '') {
        return '';
      }
      try {
        return this.$t(this.$route.meta.stepHeader);
      } catch (error) {
        return this.$route.meta.stepHeader;
      }
    },
    instructionsText() {
      if (!this.$route.meta || !this.$route.meta.instructions || this.$route.meta.instructions.trim() === '') {
        return '';
      }
      try {
        return this.$t(this.$route.meta.instructions);
      } catch (error) {
        return this.$route.meta.instructions;
      }
    },
    hasInstructions() {
      return this.instructionsText && this.instructionsText.trim() !== '';
    }
  }
}
</script>

<style>
.cov_disclaimer_text_title {
  color: #BB1122;
}
.textStepProgress {
    font-size: 16px;
    color: #666666;
    font-weight: bold;
    margin-bottom: 11px;
    padding-left:20px;
}
.textStepTitle {
  margin-left:20px;
  font-size: 28px;
  font-weight:bold;
  color: #333333;
  padding-left:20px;
}
.textInstructions {
  font-size:16px;
  text-align: left;
  margin-bottom:40px;
  padding-left:20px;
  padding-right:20px;
  color: #666666;
}
</style>
